module.exports = __webpack_public_path__ + "img/3广东省公共资源交易联合会理事单位.5941cba4.png";